import { Button, Grid } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router'
import SubCard from 'ui-component/cards/SubCard'
import { IoMdArrowRoundBack } from "react-icons/io";
import SignOnTable from './SignOnTable';
import CspMapping from './CspMapping';
import Hardware from './Hardware';
import Requests from './Requests';


const WalletPayMethod=()=> {
    const location=useLocation()
    const Nav=useNavigate();
  return (
    <Grid container>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <SubCard title={location.state.payment_type} sx={{height:"100%"}}>
                <Grid container>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Button onClick={()=>Nav(-1)} variant='outlined' ><IoMdArrowRoundBack /></Button>
                    </Grid>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        {
                            location.state.payment_type==="Sign on"?
                                <SignOnTable/>
                                :
                            location.state.payment_type==="CSP Mapping"?
                                <CspMapping/>
                                :
                            location.state.payment_type==="Hardware"?
                                <Hardware/>
                                :
                            location.state.payment_type==="Request"?
                                <Requests/>
                                :
                            null
                        }
                    </Grid>
                </Grid>

            </SubCard>
        </Grid>
    </Grid>
  )
}

export default WalletPayMethod